import React from 'react';
import { ApSignalrConsumer } from '@alixpartners/ui-utils';
import { Wrapper, Message, CheckCircleIcon, UnCheckCircleIcon } from './styles';
import { VENDOR_UPLOAD_STATUS } from 'Data/constants';
import { getStatusMessage } from 'Data/components/UploadVendorData/utils';

const MAX_LENGTH = 10;
const HIDE_DELAY = 10000; // 10 sec

const errorPoints = [
	VENDOR_UPLOAD_STATUS.UPLOADFAILED,
	VENDOR_UPLOAD_STATUS.VALIDATIONFAILED,
	VENDOR_UPLOAD_STATUS.FILEFORMATERROR,
	VENDOR_UPLOAD_STATUS.ILLEGALCHARACTERERROR,
	VENDOR_UPLOAD_STATUS.TRANSLATIONFAILED,
	VENDOR_UPLOAD_STATUS.PREPROCESSINGFAILED,
	VENDOR_UPLOAD_STATUS.DEDUPFAILED,
	VENDOR_UPLOAD_STATUS.FILEGENERATIONFAILED,
	VENDOR_UPLOAD_STATUS.PUBLISHFAILED,
	VENDOR_UPLOAD_STATUS.UNEXCEPTED_ERROR,
];
export default class Notifications extends React.Component {
	state = {
		messages: [],
	};

	showNotificationMessage = (text, action) => {
		const { messages } = this.state;
		const message = { text, action };

		this.setState({ messages: [message, ...messages] }, () => {
			const { messages } = this.state;

			if (messages.length > MAX_LENGTH) {
				this.removeNotification();
			}
		});

		setTimeout(this.removeNotification, HIDE_DELAY);
	};

	showSpendCubeChangedNotificationMessage = () => {
		this.showNotificationMessage('Spend Cube has been updated', () => {
			this.props.history.replace('/spend/');
		});

		if (typeof this.props.onMessage === 'function') {
			this.props.onMessage();
		}
	};
	showNormalizationFileUploadedNotificationMessage = () => {
		this.showNotificationMessage('Normalization File Uploaded', () => {});

		if (typeof this.props.onMessage === 'function') {
			this.props.onMessage();
		}
	};
	showNormalizationUploadNotificationMessage = () => {
		this.showNotificationMessage('Normalization File Upload Falied', () => {});

		if (typeof this.props.onMessage === 'function') {
			this.props.onMessage();
		}
	};
	showCategoryErrorNotificationMessage = statusMessage => {
		this.showNotificationMessage(
			statusMessage ? statusMessage : 'UnExpected Error Occured',
			() => {}
		);

		if (typeof this.props.onMessage === 'function') {
			this.props.onMessage();
		}
	};
	showCategoryValidationErrorNotificationMessage = () => {
		this.showNotificationMessage('Data Validation Failed ', () => {});

		if (typeof this.props.onMessage === 'function') {
			this.props.onMessage();
		}
	};
	showSkuValidationErrorNotificationMessage = () => {
		this.showNotificationMessage('SKU Validation Failed ', () => {});
		if (typeof this.props.onMessage === 'function') {
			this.props.onMessage();
		}
	};
	showSkuPipelineErrorNotificationMessage = () => {
		this.showNotificationMessage('Pipeline Falied to copy data', () => {});
		if (typeof this.props.onMessage === 'function') {
			this.props.onMessage();
		}
	};
	showNormalizationSucessdedNotificationMessage = () => {
		this.showNotificationMessage('Normalization Completed', () => {});

		if (typeof this.props.onMessage === 'function') {
			this.props.onMessage();
		}
	};
	showUploadNotificationMessage = () => {
		this.showNotificationMessage('Data Uploading ', () => {});

		if (typeof this.props.onMessage === 'function') {
			this.props.onMessage();
		}
	};
	showUploadedNotificationMessage = () => {
		this.showNotificationMessage('Data Uploaded ', () => {});

		if (typeof this.props.onMessage === 'function') {
			this.props.onMessage();
		}
	};
	showClassifierRunningNotificationMessage = () => {
		this.showNotificationMessage('Classifier Running', () => {});

		if (typeof this.props.onMessage === 'function') {
			this.props.onMessage();
		}
	};
	showCategoryDataUploadedNotificationMessage = () => {
		this.showNotificationMessage('Category Data Uploaded ', () => {});

		if (typeof this.props.onMessage === 'function') {
			this.props.onMessage();
		}
	};
	showVendorIntegrationNotificationMessage = (
		messageName,
		statusMessage,
		currentUploadStep,
		totalUploadSteps
	) => {
		this.showNotificationMessage(
			statusMessage ? statusMessage : 'UnExpected Error Occured',
			() => {}
		);

		if (typeof this.props.onMessage === 'function') {
			this.props.onMessage();
		}
	};
	showNormalizationNotificationMessage = (
		messageName,
		statusMessage,
		currentUploadStep,
		totalUploadSteps
	) => {
		let message = getStatusMessage(Number(currentUploadStep));
		this.showNotificationMessage(message, () => {});

		if (typeof this.props.onMessage === 'function') {
			this.props.onMessage();
		}
	};
	removeNotification = () => {
		if (this.state.messages.length === 0) {
			return;
		}

		const { messages } = this.state;
		const messagesCopy = messages.slice(0, -1);

		this.setState({ messages: messagesCopy });
	};

	render() {
		const { messages } = this.state;

		return (
			<Wrapper>
				{messages.map(
					({ text, action }, idx) =>
						text.includes('Falied') ? (
							<Message key={text + idx} onClick={action}>
								<UnCheckCircleIcon />
								{text}
							</Message>
						) : (
							<Message key={text + idx} onClick={action}>
								<CheckCircleIcon />
								{text}
							</Message>
						)
				)}
				<ApSignalrConsumer
					message="VendorIntegration"
					onMessage={(
						messageName,
						statusMessage,
						currentUploadStep,
						totalUploadSteps
					) => {
						this.showVendorIntegrationNotificationMessage(
							messageName,
							statusMessage,
							currentUploadStep,
							totalUploadSteps
						);
					}}
				/>
				<ApSignalrConsumer
					message="VendorIntegrationErrors"
					onMessage={(
						messageName,
						statusMessage,
						currentUploadStep,
						totalUploadSteps
					) => {
						this.showVendorIntegrationNotificationMessage(
							messageName,
							statusMessage,
							currentUploadStep,
							totalUploadSteps
						);
					}}
				/>
				<ApSignalrConsumer
					message="NormalizationInProgress"
					onMessage={(
						messageName,
						statusMessage,
						currentUploadStep,
						totalUploadSteps
					) => {
						errorPoints.includes(Number(currentUploadStep)) &&
							this.showNormalizationNotificationMessage(
								messageName,
								statusMessage,
								currentUploadStep,
								totalUploadSteps
							);
					}}
				/>
				<ApSignalrConsumer
					message="NormalizationInProgress"
					onMessage={(
						messageName,
						statusMessage,
						currentUploadStep,
						totalUploadSteps
					) => {
						console.log(
							messageName,
							statusMessage,
							currentUploadStep,
							totalUploadSteps
						);
					}}
				/>

				<ApSignalrConsumer
					message={['SpendCubeChanged']}
					onMessage={this.showSpendCubeChangedNotificationMessage}
				/>

				<ApSignalrConsumer
					message={['NormalizationFileUploaded']}
					onMessage={this.showNormalizationFileUploadedNotificationMessage}
				/>
				<ApSignalrConsumer
					message={['ClassifierRunInitiated']}
					onMessage={this.showClassifierRunningNotificationMessage}
				/>

				<ApSignalrConsumer
					message={['NormalizationFileUploadFalied']}
					onMessage={this.showNormalizationUploadNotificationMessage}
				/>
				<ApSignalrConsumer
					message={['DataUploading']}
					onMessage={this.showUploadNotificationMessage}
				/>
				<ApSignalrConsumer
					message={['DataUploaded']}
					onMessage={this.showUploadedNotificationMessage}
				/>

				<ApSignalrConsumer
					message={['ClassifierRunning']}
					onMessage={this.showClassifierRunningNotificationMessage}
				/>
				<ApSignalrConsumer
					message={['CategoryDataPipelineFailed']}
					onMessage={(
						messageKey,
						statusMessage,
						currentNormalizationStep,
						totalNormalizationSteps
					) => this.showCategoryErrorNotificationMessage(statusMessage)}
				/>
				<ApSignalrConsumer
					message={['CategoryDataUploadFailed']}
					onMessage={this.showCategoryErrorNotificationMessage}
				/>
				<ApSignalrConsumer
					message={['CategoryDataValidationFailed']}
					onMessage={this.showCategoryValidationErrorNotificationMessage}
				/>
				<ApSignalrConsumer
					message={['SKUDataValidationFailed']}
					onMessage={this.showSkuValidationErrorNotificationMessage}
				/>
				<ApSignalrConsumer
					message={['SKUDataPipelineFailed']}
					onMessage={this.showSkuPipelineErrorNotificationMessage}
				/>
				<ApSignalrConsumer
					message={['SKUDataPipelineInProgress']}
					onMessage={(
						messageKey,
						statusMessage,
						currentSkuStep,
						totalSkuSteps
					) => {
						if (Number(currentSkuStep) === 8) {
							this.showUploadedNotificationMessage(statusMessage);
						}
					}}
				/>
				<ApSignalrConsumer
					message={['CategoryDataUploaded']}
					onMessage={this.showCategoryDataUploadedNotificationMessage}
				/>
				<ApSignalrConsumer
					message={['NormalizationCompleted']}
					onMessage={this.showNormalizationSucessdedNotificationMessage}
				/>
			</Wrapper>
		);
	}
}
